module.exports = __webpack_public_path__ + "resources/img/img_security_ahnlab_vaips_en.ca8465b91ccc24d550a48d5408cbc87e.png";